import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Displays window confirm when user tries to leave page when form is dirty.
 * Must be used on form element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <form
 *   data-controller="unsaved-changes"
 *   data-action="input->unsaved-changes#setDirty beforeunload@window->unsaved-changes#block turbo:before-visit@window->unsaved-changes#block"
 * ></form>
 *
 * Notes
 * -------
 *
 * If you want to exclude form input from being considered as dirty, you can add the data-unsaved-changes-exclude attribute to the input.
 *
 */
export default class extends Controller {
    connect() {
        this.dirty = false;
    }
    removeDirty() {
        this.dirty = false;
    }
    setDirty(e) {
        if (e.target instanceof HTMLInputElement &&
            e.target.getAttribute('data-unsaved-changes-exclude'))
            return;
        this.dirty = true;
    }
    block(event) {
        if (!this.dirty)
            return;
        if (event.type === 'beforeunload') {
            event.preventDefault();
            // Included for legacy support, e.g. Chrome/Edge < 119
            event.returnValue = true;
        }
        if (event.type === 'turbo:before-visit') {
            if (!window.confirm('You have attempted to leave this page. Changes that you made may not be saved.'))
                event.preventDefault();
        }
    }
}
